import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import UiKit from './views/pages/UiKit.vue';
import OrderOverview from './views/pages/OrderOverview.vue';
import MailLogOverview from './views/pages/MailLogOverview.vue';
import SurveyAnswersOverview from './views/pages/SurveyAnswersOverview.vue';
import SupplierCandidateOverview from "./views/pages/SupplierCandidateOverview.vue";
import UserDetectDoubles from "./views/pages/UserDetectDoubles.vue";
import MollieDetails from "./views/pages/MollieDetails.vue";
import AssignManualTickets from "./views/pages/AssignManualTickets.vue";
import CarRequestForm from "./views/pages/CarRequestForm.vue";
import BarcodeValidation from "./views/pages/BarcodeValidation.vue";
import Export from "./views/pages/Export.vue";
import PickupLocation from "./views/pages/PickupLocation.vue";
import GDPRDelete from "./views/pages/GDPRDelete.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/ui-kit',
        component: UiKit,
        meta: {
            title: "UI kit",
        },
    },
    {
        path: '/barcode/validation/:hashId',
        name: 'barcode-validation',
        component: BarcodeValidation,
        meta: {
            title: "Barcode validation",
        },
    },
    {
        path: '/user/detect-doubles',
        name: 'user-detect-doubles',
        component: UserDetectDoubles,
        meta: {
            title: "User detect doubles",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'user-detect-doubles-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/order-overview/:orderCode',
        name: 'order-overview',
        component: OrderOverview,
        meta: {
            title: "Order overview",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'order-overview-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/mail-log-overview/:hashId',
        name: 'mail-log-overview',
        component: MailLogOverview,
        meta: {
            title: "Mail log overview",
        }
    },
    {
        path: '/supplier/candidate/:hashId',
        name: 'supplier-candidate-overview',
        component: SupplierCandidateOverview,
        meta: {
            title: "Supplier candidate overview",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'supplier-candidate-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/survey-answers-overview/:hashId',
        name: 'survey-answers-overview',
        component: SurveyAnswersOverview,
        meta: {
            title: "Survey answers overview",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'survey-answers-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/mollie-details/:hashId',
        name: 'mollie-details',
        component: MollieDetails,
        meta: {
            title: "Mollie details",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'mollie-details-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/assign-manual-tickets/:hashId',
        name: 'mollie-assign-manual-tickets',
        component: AssignManualTickets,
        meta: {
            title: "Assign manual tickets",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'assign-manual-tickets-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/gdpr-delete/:hashId',
        name: 'gdpr-delete',
        component: GDPRDelete,
        meta: {
            title: "GDPR delete",
        }
    },
    {
        path: '/car-request/form/:hashId',
        name: 'car-request-form',
        component: CarRequestForm,
        meta: {
            title: "Car request form",
        }
    },
    {
        path: '/export/:exportBundle/:exportDefinition',
        name: 'export',
        component: Export,
        meta: {
            title: "Export",
        }
    },
    {
        path: '/product/pickup-location/:hashId',
        name: 'product-pickup',
        component: PickupLocation,
        meta: {
            title: "PickupLocation",
        }
    },
];

const dashboardRoute = {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home'
    };
routes = [dashboardRoute,...Vue.cmsRouter.setRoutes(routes)];

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
